import Vue from 'vue'
import Router from 'vue-router'
import store from "./store"

import Login from "./components/login";
import Main from "./views/main";

Vue.use(Router)

export default new Router({
  base: "/admin/",
  routes: [
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/_",
      name: "main",
      component: Main,
      beforeEnter: (to, from, next) =>  store.getters.loggedIn ? next() : next("/"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("./views/dashboard")
        },
        {
          path: "/users",
          name: "users",
          component: () => import("./views/users")
        },
        {
          path: "/legislations",
          name: "legislations",
          component: () => import("./views/legislations")
        },
        {
          path: "/legislations/:id",
          name: "legislation",
          component: () => import("./views/legislation")
        },
        {
          path: "/sections/:id",
          name: "sections",
          component: () => import("./views/section")
        },
        {
          path: "/clauses/:id",
          name: "clauses",
          component: () => import("./views/clause")
        }
      ]
    }
  ]
})
